<app-dialog-component (okEmitter)="clickedConvertToTeam()" [formGroup]="chooseStructure"
                      [saveAndCloseLabel]="saveAndCloseLabel$ | async" [title]="title$ | async">
  <app-convert-topic-draft-tree *ngFor="let company of companyStructures$ | async"
                                [substructure]="company"></app-convert-topic-draft-tree>
</app-dialog-component>
